// src/enums.ts
var UserRole = {
  SUPER_ADMIN: "SUPER_ADMIN",
  ADMIN: "ADMIN",
  TUTOR: "TUTOR",
  STUDENT: "STUDENT",
  PARENT: "PARENT"
};
var LOGIN_ROLES = [UserRole.TUTOR, UserRole.STUDENT];
var SELF_REGISTRABLE_ROLES = [UserRole.TUTOR, UserRole.STUDENT];
var UserStatus = {
  ACTIVE: "ACTIVE",
  INVITED: "INVITED",
  SUSPENDED: "SUSPENDED",
  DEACTIVATED: "DEACTIVATED"
};
var TutorStudentStatus = {
  ACTIVE: "ACTIVE",
  PAUSED: "PAUSED",
  ENDED: "ENDED"
};
var InvitationStatus = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
  REVOKED: "REVOKED",
  EXPIRED: "EXPIRED"
};
var EducationLevel = {
  KS2: "KS2",
  KS3: "KS3",
  GCSE: "GCSE",
  A_LEVEL: "A_LEVEL",
  IB: "IB",
  UNIVERSITY: "UNIVERSITY",
  OTHER: "OTHER"
};
var LessonStatus = {
  SCHEDULED: "SCHEDULED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  NO_SHOW: "NO_SHOW"
};
var LessonParticipantRole = {
  HOST: "HOST",
  LEARNER: "LEARNER",
  OBSERVER: "OBSERVER"
};
var AttendanceStatus = {
  PRESENT: "PRESENT",
  LATE: "LATE",
  ABSENT: "ABSENT",
  EXCUSED: "EXCUSED"
};
var HomeworkStatus = {
  DRAFT: "DRAFT",
  PUBLISHED: "PUBLISHED",
  ARCHIVED: "ARCHIVED"
};
var AssignmentStatus = {
  ASSIGNED: "ASSIGNED",
  IN_PROGRESS: "IN_PROGRESS",
  SUBMITTED: "SUBMITTED",
  MARKED: "MARKED",
  RETURNED: "RETURNED",
  OVERDUE: "OVERDUE"
};
var SubmissionStatus = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  RESUBMITTED: "RESUBMITTED",
  MARKED: "MARKED"
};
var AssessmentType = {
  DIAGNOSTIC: "DIAGNOSTIC",
  FORMATIVE: "FORMATIVE",
  SUMMATIVE: "SUMMATIVE",
  MOCK_EXAM: "MOCK_EXAM"
};
var MasteryLevel = {
  NOT_STARTED: "NOT_STARTED",
  EMERGING: "EMERGING",
  DEVELOPING: "DEVELOPING",
  SECURE: "SECURE",
  MASTERED: "MASTERED"
};
var ProgressTrend = {
  IMPROVING: "IMPROVING",
  STEADY: "STEADY",
  DECLINING: "DECLINING"
};
var FilePurpose = {
  AVATAR: "AVATAR",
  RESOURCE: "RESOURCE",
  HOMEWORK_ATTACHMENT: "HOMEWORK_ATTACHMENT",
  SUBMISSION: "SUBMISSION",
  WHITEBOARD_SNAPSHOT: "WHITEBOARD_SNAPSHOT",
  LESSON_RECORDING: "LESSON_RECORDING",
  CHAT_ATTACHMENT: "CHAT_ATTACHMENT"
};
var ChatMessageType = {
  TEXT: "TEXT",
  FILE: "FILE",
  SYSTEM: "SYSTEM"
};
var NotificationType = {
  INVITATION_RECEIVED: "INVITATION_RECEIVED",
  INVITATION_ACCEPTED: "INVITATION_ACCEPTED",
  LESSON_SCHEDULED: "LESSON_SCHEDULED",
  LESSON_REMINDER: "LESSON_REMINDER",
  LESSON_CANCELLED: "LESSON_CANCELLED",
  HOMEWORK_ASSIGNED: "HOMEWORK_ASSIGNED",
  HOMEWORK_DUE_SOON: "HOMEWORK_DUE_SOON",
  HOMEWORK_SUBMITTED: "HOMEWORK_SUBMITTED",
  HOMEWORK_MARKED: "HOMEWORK_MARKED",
  PROGRESS_ALERT: "PROGRESS_ALERT",
  RESOURCE_SHARED: "RESOURCE_SHARED",
  SYSTEM: "SYSTEM"
};
var WhiteboardToolType = {
  PEN: "PEN",
  HIGHLIGHTER: "HIGHLIGHTER",
  ERASER: "ERASER",
  LINE: "LINE",
  RECTANGLE: "RECTANGLE",
  ELLIPSE: "ELLIPSE",
  ARROW: "ARROW",
  TEXT: "TEXT",
  SELECT: "SELECT"
};
var AuditAction = {
  ACCOUNT_REGISTERED: "ACCOUNT_REGISTERED",
  STUDENT_INVITED: "STUDENT_INVITED",
  INVITATION_ACCEPTED: "INVITATION_ACCEPTED",
  INVITATION_DECLINED: "INVITATION_DECLINED",
  INVITATION_REVOKED: "INVITATION_REVOKED",
  LESSON_CREATED: "LESSON_CREATED",
  LESSON_UPDATED: "LESSON_UPDATED",
  LESSON_CANCELLED: "LESSON_CANCELLED",
  HOMEWORK_CREATED: "HOMEWORK_CREATED",
  HOMEWORK_ASSIGNED: "HOMEWORK_ASSIGNED",
  LOGIN_SUCCEEDED: "LOGIN_SUCCEEDED",
  LOGIN_FAILED: "LOGIN_FAILED",
  LOGOUT: "LOGOUT",
  TOKEN_REFRESHED: "TOKEN_REFRESHED",
  PASSWORD_RESET_REQUESTED: "PASSWORD_RESET_REQUESTED",
  PASSWORD_RESET_COMPLETED: "PASSWORD_RESET_COMPLETED",
  LESSON_ACCESS_DENIED: "LESSON_ACCESS_DENIED",
  CLASSROOM_JOINED: "CLASSROOM_JOINED",
  CLASSROOM_LEFT: "CLASSROOM_LEFT",
  LESSON_STARTED: "LESSON_STARTED",
  LESSON_ENDED: "LESSON_ENDED",
  HOMEWORK_SUBMITTED: "HOMEWORK_SUBMITTED",
  HOMEWORK_MARKED: "HOMEWORK_MARKED"
};

// src/rbac.ts
var Permission = {
  // Lessons & classroom
  LESSON_VIEW_OWN: "lesson:view:own",
  LESSON_VIEW_ANY: "lesson:view:any",
  LESSON_CREATE: "lesson:create",
  LESSON_UPDATE: "lesson:update",
  LESSON_CANCEL: "lesson:cancel",
  CLASSROOM_JOIN: "classroom:join",
  CLASSROOM_HOST: "classroom:host",
  CLASSROOM_END: "classroom:end",
  // Whiteboard
  WHITEBOARD_DRAW: "whiteboard:draw",
  WHITEBOARD_MANAGE_PAGES: "whiteboard:manage-pages",
  WHITEBOARD_CLEAR: "whiteboard:clear",
  // Students
  STUDENT_LIST: "student:list",
  STUDENT_VIEW_PROFILE: "student:view-profile",
  STUDENT_MANAGE: "student:manage",
  // Homework
  HOMEWORK_VIEW_OWN: "homework:view:own",
  HOMEWORK_CREATE: "homework:create",
  HOMEWORK_ASSIGN: "homework:assign",
  HOMEWORK_SUBMIT: "homework:submit",
  HOMEWORK_MARK: "homework:mark",
  // Assessments & progress
  ASSESSMENT_VIEW: "assessment:view",
  ASSESSMENT_MANAGE: "assessment:manage",
  PROGRESS_VIEW_OWN: "progress:view:own",
  PROGRESS_VIEW_STUDENTS: "progress:view:students",
  PROGRESS_MANAGE: "progress:manage",
  // Resources & files
  RESOURCE_VIEW: "resource:view",
  RESOURCE_UPLOAD: "resource:upload",
  RESOURCE_MANAGE: "resource:manage",
  // Platform administration
  USER_MANAGE: "user:manage",
  AUDIT_VIEW: "audit:view"
};
var STUDENT_PERMISSIONS = [
  Permission.LESSON_VIEW_OWN,
  Permission.CLASSROOM_JOIN,
  Permission.WHITEBOARD_DRAW,
  Permission.HOMEWORK_VIEW_OWN,
  Permission.HOMEWORK_SUBMIT,
  Permission.PROGRESS_VIEW_OWN,
  Permission.ASSESSMENT_VIEW,
  Permission.RESOURCE_VIEW,
  Permission.RESOURCE_UPLOAD
];
var TUTOR_PERMISSIONS = [
  Permission.LESSON_VIEW_OWN,
  Permission.LESSON_CREATE,
  Permission.LESSON_UPDATE,
  Permission.LESSON_CANCEL,
  Permission.CLASSROOM_JOIN,
  Permission.CLASSROOM_HOST,
  Permission.CLASSROOM_END,
  Permission.WHITEBOARD_DRAW,
  Permission.WHITEBOARD_MANAGE_PAGES,
  Permission.WHITEBOARD_CLEAR,
  Permission.STUDENT_LIST,
  Permission.STUDENT_VIEW_PROFILE,
  Permission.HOMEWORK_VIEW_OWN,
  Permission.HOMEWORK_CREATE,
  Permission.HOMEWORK_ASSIGN,
  Permission.HOMEWORK_MARK,
  Permission.ASSESSMENT_VIEW,
  Permission.ASSESSMENT_MANAGE,
  Permission.PROGRESS_VIEW_STUDENTS,
  Permission.PROGRESS_MANAGE,
  Permission.RESOURCE_VIEW,
  Permission.RESOURCE_UPLOAD,
  Permission.RESOURCE_MANAGE
];
var PARENT_PERMISSIONS = [
  Permission.LESSON_VIEW_OWN,
  Permission.HOMEWORK_VIEW_OWN,
  Permission.PROGRESS_VIEW_OWN,
  Permission.ASSESSMENT_VIEW,
  Permission.RESOURCE_VIEW
];
var ADMIN_PERMISSIONS = [
  ...TUTOR_PERMISSIONS,
  Permission.LESSON_VIEW_ANY,
  Permission.STUDENT_MANAGE,
  Permission.USER_MANAGE,
  Permission.AUDIT_VIEW
];
var ROLE_PERMISSIONS = {
  [UserRole.SUPER_ADMIN]: Object.values(Permission),
  [UserRole.ADMIN]: ADMIN_PERMISSIONS,
  [UserRole.TUTOR]: TUTOR_PERMISSIONS,
  [UserRole.STUDENT]: STUDENT_PERMISSIONS,
  [UserRole.PARENT]: PARENT_PERMISSIONS
};
function permissionsForRole(role) {
  return ROLE_PERMISSIONS[role] ?? [];
}
function roleHasPermission(role, permission) {
  return permissionsForRole(role).includes(permission);
}
function roleHasAnyPermission(role, permissions) {
  return permissions.some((p) => roleHasPermission(role, p));
}
function roleHasAllPermissions(role, permissions) {
  return permissions.every((p) => roleHasPermission(role, p));
}
var ROLE_HOME_ROUTE = {
  [UserRole.SUPER_ADMIN]: "/admin/dashboard",
  [UserRole.ADMIN]: "/admin/dashboard",
  [UserRole.TUTOR]: "/tutor/dashboard",
  [UserRole.STUDENT]: "/student/dashboard",
  [UserRole.PARENT]: "/parent/dashboard"
};

// src/constants.ts
var JOIN_WINDOW_MINUTES_BEFORE = 15;
var JOIN_WINDOW_MINUTES_AFTER = 30;
var PASSWORD_MIN_LENGTH = 8;
var PASSWORD_MAX_LENGTH = 128;
var DEFAULT_PAGE_SIZE = 20;
var MAX_PAGE_SIZE = 100;
var MAX_UPLOAD_BYTES = 25 * 1024 * 1024;
var ALLOWED_UPLOAD_MIME_TYPES = [
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
  "image/svg+xml",
  "application/pdf",
  "text/plain",
  "text/csv",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/zip"
];
var REFRESH_TOKEN_COOKIE = "tutor_rt";
var WHITEBOARD_COLOURS = [
  "#0f172a",
  "#dc2626",
  "#2563eb",
  "#16a34a",
  "#d97706",
  "#9333ea",
  "#0891b2",
  "#db2777"
];
var WHITEBOARD_STROKE_WIDTHS = [2, 4, 8, 16];
var ErrorCode = {
  VALIDATION_FAILED: "VALIDATION_FAILED",
  INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
  UNAUTHENTICATED: "UNAUTHENTICATED",
  TOKEN_EXPIRED: "TOKEN_EXPIRED",
  FORBIDDEN: "FORBIDDEN",
  NOT_FOUND: "NOT_FOUND",
  CONFLICT: "CONFLICT",
  ACCOUNT_SUSPENDED: "ACCOUNT_SUSPENDED",
  LESSON_ACCESS_DENIED: "LESSON_ACCESS_DENIED",
  CLASSROOM_CLOSED: "CLASSROOM_CLOSED",
  RATE_LIMITED: "RATE_LIMITED",
  PAYLOAD_TOO_LARGE: "PAYLOAD_TOO_LARGE",
  INTERNAL_ERROR: "INTERNAL_ERROR"
};

// src/utils.ts
function fullName(first, last) {
  return `${first} ${last}`.trim();
}
function initials(first, last) {
  return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
}
function partOfDay(date = /* @__PURE__ */ new Date()) {
  const hour = date.getHours();
  if (hour < 12) return "morning";
  if (hour < 18) return "afternoon";
  return "evening";
}
function isWithinJoinWindow(scheduledStart, scheduledEnd, status, now = /* @__PURE__ */ new Date()) {
  if (status === LessonStatus.CANCELLED || status === LessonStatus.COMPLETED) return false;
  if (status === LessonStatus.IN_PROGRESS) return true;
  const start = new Date(scheduledStart).getTime();
  const end = new Date(scheduledEnd).getTime();
  const t = now.getTime();
  return t >= start - JOIN_WINDOW_MINUTES_BEFORE * 6e4 && t <= end + JOIN_WINDOW_MINUTES_AFTER * 6e4;
}
function percentage(value, total) {
  if (total <= 0) return 0;
  return Math.round(value / total * 100);
}
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

export { ALLOWED_UPLOAD_MIME_TYPES, AssessmentType, AssignmentStatus, AttendanceStatus, AuditAction, ChatMessageType, DEFAULT_PAGE_SIZE, EducationLevel, ErrorCode, FilePurpose, HomeworkStatus, InvitationStatus, JOIN_WINDOW_MINUTES_AFTER, JOIN_WINDOW_MINUTES_BEFORE, LOGIN_ROLES, LessonParticipantRole, LessonStatus, MAX_PAGE_SIZE, MAX_UPLOAD_BYTES, MasteryLevel, NotificationType, PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH, Permission, ProgressTrend, REFRESH_TOKEN_COOKIE, ROLE_HOME_ROUTE, ROLE_PERMISSIONS, SELF_REGISTRABLE_ROLES, SubmissionStatus, TutorStudentStatus, UserRole, UserStatus, WHITEBOARD_COLOURS, WHITEBOARD_STROKE_WIDTHS, WhiteboardToolType, clamp, fullName, initials, isWithinJoinWindow, partOfDay, percentage, permissionsForRole, roleHasAllPermissions, roleHasAnyPermission, roleHasPermission };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map